import moment from "moment";

export default class QuizTimer extends PIXI.Container {
    constructor(startTime = 300000) {
        super();

        this._running = false;

        this._startTime = startTime;
        this._duration = startTime + 1000;

        this._outputLabel = new PIXI.extras.BitmapText(this.formatTime(Math.min(this._duration, this._startTime)), {font: "40px BBC Reith Sans", align: "left"});
        this._outputLabel.anchor.set(0, 0.5);
        this.addChild(this._outputLabel);

        this.reset();
        this.update(0);
    }

    update(dt) {
        if (this._running)
        {
            if (++this._frame % 100) {
                this._frameAlt = !this._frameAlt;
            }
            this._duration -= dt * 1000;
            this._outputLabel.text = this.formatTime(Math.min(this._duration, this._startTime));
            this._outputLabel.tint = this._duration < 0 ? 0xFF0000 : 0xFFFFFF;
        }
    }

    start()
    {
        this.reset();
        this._running = true;
    }

    reset()
    {
        this._duration = moment.duration(this._startTime + 1000);
        this._running = false;
    }

    formatTime(ms = 0)
    {
        let seconds = ms / 1000;
        seconds = seconds % 3600;
        let minutes = parseInt(seconds / 60);
        seconds = seconds % 60;
        return (ms < 0 ? "+" : "") + (P3.utils.padNum(minutes, 2) + ":" + P3.utils.padNum(parseInt(seconds), 2)).toString();
    }

    get startTime()
    {
        return this._startTime;
    }

    get running()
    {
        return this._running;
    }
}